import * as _ from "lodash";

export class DataSet {
    public id: string | null = null;
    public status = "Active";
    public creator: any = null;
    public lastupdater: any = null;

    constructor(data?: object) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: object): void {
        _.merge(this, data);
    }
}
